<template>
  <div>
    <p-overlay></p-overlay>
    <div
      ref="dialogWrapper"
      aria-modal="true"
      role="dialog"
      :aria-label="title"
      class="p-dialog-wrapper"
    >
      <div class="p-dialog" :style="styleList">
        <p-toolbar flat dense :color="type">
          <div class="p-dialog-title">
            {{ title }}
          </div>
          <p-button v-if="hasCloseButton" class="p-dialog-close" dense @click.prevent="close">
            <p-icon dense>
              close
            </p-icon>
          </p-button>
        </p-toolbar>
        <div class="p-dialog-content">
          <slot name="content"></slot>
        </div>
        <div v-if="_.component.hasSlot(this, 'actions')" class="p-dialog-actions">
          <slot name="actions"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
      title: { type: String, default: undefined },
      type: { type: String, default: 'base' },
      hasCloseButton: { type: Boolean, default: true },
    },
    data: () => ({
      maxHeight: undefined as number | undefined,
      maxWidth: undefined as number | undefined,
    }),
    computed: {
      styleList(): Record<string, any> {
        return {
          'max-height': this.maxHeight ? `${this.maxHeight}px` : undefined,
          'max-width': this.maxWidth ? `${this.maxWidth}px` : undefined,
        };
      },
    },
    mounted() {
      document.addEventListener('keydown', this.onKeyDown);
    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.onKeyDown);
    },
    methods: {
      onKeyDown(evt: KeyboardEvent) {
        evt = evt || window.event;
        if (evt.key === 'Escape' || evt.key === 'Esc') {
          this.closeOnEsc();
        }
      },
      closeOnEsc() {
        this.$emit('closeOnEsc');
        if (this.hasCloseButton) {
          this.close();
        }
      },
      close() {
        this.$emit('close');
        this.$el.remove();
      },
    },
  });
</script>
